var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 6C0.667969 2.68629 3.35426 0 6.66797 0H42.668C45.9817 0 48.668 2.68629 48.668 6V42C48.668 45.3137 45.9817 48 42.668 48H6.66797C3.35426 48 0.667969 45.3137 0.667969 42V6Z",
    fill: "var(--klothed-bgColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16797 6C1.16797 2.96243 3.6304 0.5 6.66797 0.5H42.668C45.7055 0.5 48.168 2.96243 48.168 6V42C48.168 45.0376 45.7055 47.5 42.668 47.5H6.66797C3.6304 47.5 1.16797 45.0376 1.16797 42V6Z",
    stroke: "var(--klothed-textColor)",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4735 22.0415H33.668V22H24.668V26H30.3195C29.495 28.3285 27.2795 30 24.668 30C21.3545 30 18.668 27.3135 18.668 24C18.668 20.6865 21.3545 18 24.668 18C26.1975 18 27.589 18.577 28.6485 19.5195L31.477 16.691C29.691 15.0265 27.302 14 24.668 14C19.1455 14 14.668 18.4775 14.668 24C14.668 29.5225 19.1455 34 24.668 34C30.1905 34 34.668 29.5225 34.668 24C34.668 23.3295 34.599 22.675 34.4735 22.0415Z",
    fill: "var(--klothed-textColor)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 19.3455L19.1058 21.755C19.9948 19.554 22.1478 18 24.6673 18C26.1968 18 27.5883 18.577 28.6478 19.5195L31.4763 16.691C29.6903 15.0265 27.3013 14 24.6673 14C20.8263 14 17.4953 16.1685 15.8203 19.3455Z",
    fill: "var(--klothed-textColor)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6681 33.9997C27.2511 33.9997 29.5981 33.0112 31.3726 31.4037L28.2776 28.7847C27.2399 29.5739 25.9719 30.0008 24.6681 29.9997C22.0671 29.9997 19.8586 28.3412 19.0266 26.0267L15.7656 28.5392C17.4206 31.7777 20.7816 33.9997 24.6681 33.9997Z",
    fill: "var(--klothed-textColor)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4735 22.0416H33.668V22.0001H24.668V26.0001H30.3195C29.9251 27.1083 29.2146 28.0767 28.276 28.7856L28.2775 28.7846L31.3725 31.4036C31.1535 31.6026 34.668 29.0001 34.668 24.0001C34.668 23.3296 34.599 22.6751 34.4735 22.0416Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8013c902ea12e2139ffcf8f370f887a2.svg";
export { ForwardRef as ReactComponent };